/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'
import {jwtDecode} from 'jwt-decode'
import {Modal, Row, Col} from 'react-bootstrap'
import ButtonComp from '../../../components/Button'
import TextField from '../../../components/TextField'
import Swal from 'sweetalert2'
import {DEFAULT_ERROR_MODAL} from '../../../constants/errors/error-model'
import {ActivateLicenseService} from '../../../service/license.service/license.service'
import {loginRequest} from '../../../helpers/msal-config'
import {useMsal} from '@azure/msal-react'
import {getUserByToken, login, loginAD} from '../core/_requests'
import {useNavigate} from 'react-router-dom'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

// const initialValues = {
//   email: 'admin@demo.com',
//   password: 'demo',
// }
const initialValues = {
  email: '',
  password: '',
}
const initialLicense = {
  license: '',
}
/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const {instance} = useMsal()
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const [modalShow, setModalShow] = useState(false)

  const navigate = useNavigate()

  const formik = useFormik({
    initialValues,
    // validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await login(values.email, values.password)
        localStorage.setItem('accessToken', auth.data.token)
        localStorage.setItem('refreshToken', auth.data.refreshToken)
        let decoded = jwtDecode(auth.data.token) as any
        decoded = {...decoded, api_token: auth.data.token}

        saveAuth(decoded)
        setCurrentUser(decoded)
        if (localStorage.getItem('redirect')) {
          const redirect = localStorage.getItem('redirect') as string
          window.location.href = redirect
        } else {
          window.location.href = '/'
        }
      } catch (error: any) {
        if (error.response.status === 402) {
          setModalShow(true)
        } else {
          console.error(error)
          saveAuth(undefined)
          setStatus('The login details are incorrect')
          await Swal.fire(DEFAULT_ERROR_MODAL(error.response.data.message))
        }
        setSubmitting(false)
        setLoading(false)
      }
    },
  })
  const formikLicense = useFormik({
    initialValues: initialLicense,
    // validationSchema: loginSchema,
    onSubmit: async (values, {setSubmitting}) => {
      setLoading(true)
      const activateLicense = new ActivateLicenseService()
      activateLicense
        .request(values)
        .then((res) => {
          formik.handleSubmit()
        })
        .catch(async (error) => {
          formik.handleSubmit()
          await Swal.fire(DEFAULT_ERROR_MODAL(error.response.data.message))
        })
      setSubmitting(false)
      setLoading(false)
    },
  })
  const handleClose = () => {
    setModalShow(false)
  }

  const adLogin = async () => {
    let adToken: any
    setLoading(true)
    await instance.loginPopup(loginRequest).then((_) => {
      console.log('login response')
      for (const key in localStorage) {
        if (key.includes('accesstoken')) {
          adToken = JSON.parse(localStorage[key])
          break
        }
      }
    })
    console.log('adToken', adToken)
    adToken = adToken?.secret || ''
    try {
      if (adToken) {
        const {data: auth}: any = await loginAD(adToken)
        localStorage.clear()
        localStorage.setItem('accessToken', auth.data.token)
        localStorage.setItem('refreshToken', auth.data.refreshToken)
        let decoded = jwtDecode(auth.data.token) as any
        decoded = {...decoded, api_token: auth.data.token}

        saveAuth(decoded)
        setCurrentUser(decoded)
        setLoading(false)
        window.location.href = '/'
      } else {
        console.error('no adToken')
        setLoading(false)
        navigate('/auth/login')
      }
    } catch (error: any) {
      // console.error('login ad error', error)
      // if (error.response.status === 402) {
      //   setModalShow(true)
      // } else {
      //   saveAuth(undefined)
      //   await Swal.fire(DEFAULT_ERROR_MODAL(error.response.data.message))
      //   setLoading(false)
      //   navigate('/auth/login')
      // }

      console.error(123123, error)
      saveAuth(undefined)
      if (error.response.status === 402) {
        setModalShow(true)
      } else {
        await Swal.fire(DEFAULT_ERROR_MODAL(error.response.data.message))
        setLoading(false)
        navigate('/auth/login')
      }
    }
  }

  return (
    <>
      {/* begin::Heading */}
      <div className='center app-sidebar-logo-default theme-light-show mb-11'>
        <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-tag.png')} className='h-50px' />
      </div>
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Sign In</h1>
      </div>
      {/* begin::Heading */}
      <div className='d-grid mb-10'>
        <button
          type='button'
          id='kt_ad_sign_in_submit'
          className='btn btn-secondary'
          disabled={loading}
          onClick={adLogin}
        >
          {!loading && <span className='indicator-label'>Login With AD</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>

      <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
      </div>
      <form
        className='form w-100'
        onSubmit={formik.handleSubmit}
        noValidate
        id='kt_login_signin_form'
      >
        <div className='fv-row mb-8'>
          <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
          <input
            placeholder='Email'
            {...formik.getFieldProps('email')}
            className={clsx('form-control bg-transparent')}
            type='email'
            name='email'
            autoComplete='off'
            disabled={loading}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          )}
        </div>

        {/* begin::Form group */}
        <div className='fv-row mb-3'>
          <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
          <input
            type='password'
            autoComplete='off'
            {...formik.getFieldProps('password')}
            className={clsx('form-control bg-transparent')}
            disabled={loading}
          />
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.password}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Wrapper */}
        <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
          <div />

          {/* begin::Link */}
          <Link to='/auth/forgot-password' className='link-primary'>
            Forgot Password ?
          </Link>
          {/* end::Link */}
        </div>
        {/* end::Wrapper */}

        {/* begin::Action */}
        <div className='d-grid mb-10'>
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-primary'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label'>Continue</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Action */}

        <div className='text-gray-500 text-center fw-semibold fs-6'>
          Version {process.env.REACT_APP_VERSION}
        </div>
      </form>
      <Modal
        show={modalShow}
        onHide={handleClose}
        centered
        size='lg'
        closeOnClickOutside={false}
        closeOnEscape={false}
        backdrop='static'
      >
        <form onSubmit={formikLicense.handleSubmit} noValidate>
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter'>Activate License</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={12}>
                <TextField textarea formik={formikLicense} name={'license'} label='License' />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <ButtonComp type={'submit'} variant='success' doing={formikLicense.isSubmitting}>
              Submit
            </ButtonComp>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  )
}
